export const ONBOARDING_CONTAINER_SIZES = {
  defaultWidth: "26.125rem",
  defaultHeight: "25.625rem",
};
